import i18next from 'i18next';

import { Variables } from '../types';

const templating = i18next.createInstance();
templating.init({
    interpolation: {
        // We want to replace all variables, even if they are not found in the context.
        // Missing variables will be replaced with an empty string.
        skipOnVariables: false
    }
});

// Add a formatter for the toISOString function.
templating.services.formatter?.add('toISOString', (value) =>
    new Date(value).toISOString()
);

// We are using translate function to do a safe substitution for context values.
// A fresh instance is set with a unique context and language to prevent colusion
const t = templating.getFixedT('en', 'context');

export function templateInterpolation(
    template: unknown,
    variables: Variables = {}
) {
    return typeof template !== 'string'
        ? String(template)
        : t(template, variables);
}
